import { useEffect, useState, useCallback } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import config from "../../config";
import axios from "axios";

function TabActivityReport() {
  const [reportData, setReportData] = useState([]);
  const [intro, setIntro] = useState("");
  const [tester, setTester] = useState("");
  const [coordinator, setCoodinator] = useState("");
  const [coodinatorPhoneNum, setCoodinatorPhoneNum] = useState("");
  const [responsible, setResponsible] = useState("");
  const [responsiblePhoneNum, setResponsiblePhoneNum] = useState("");
  const [utility, setUtility] = useState("");
  const [confirmDoc, setConfirmDoc] = useState("");
  const [explanation, setExplanation] = useState("");
  const [cfoMore, setCFOMore] = useState("");
  const [facility, setFacility] = useState("");
  const [selectedImage, setSelectedImage] = useState(null); // เพิ่ม state เพื่อเก็บรูปภาพที่ถูกเลือก
  const [ogImage, setOgImage] = useState(null);
  const { campus_id, id, years, fac_id } = useParams();

  const fetchData = useCallback(async () => {
    try {
      const res = await axios.get(config.urlApi + `/report/dipictDataReport/${id}`);
      setReportData(res.data);
    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: e.message,
      });
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleQuillChange = (value, setter) => {
    setter(value);
  };

  const handlerGenerateReport = async (e) => {
    try {
      e.preventDefault();

      if (intro === '' || tester === '' || coordinator === '' || coodinatorPhoneNum === '' || responsible === '' || responsiblePhoneNum === '' || utility === '' || confirmDoc === '' || explanation === '' || facility === '' || cfoMore === '' || selectedImage === '' || ogImage === '') {
        Swal.fire({
          icon: 'warning',
          text: 'กรุณากรอกข้อมูลให้ครบถ้วน'
        })

      } else {

        const formData = new FormData();
        formData.append('activityperiod_id', id);
        formData.append('intro', intro);
        formData.append('tester', tester);
        formData.append('coordinator', coordinator);
        formData.append('coordinatorPhoneNum', coodinatorPhoneNum);
        formData.append('responsible', responsible);
        formData.append('responsiblePhoneNum', responsiblePhoneNum);
        formData.append('utility', utility);
        formData.append('facility', facility);
        formData.append('confirmDoc', confirmDoc);
        formData.append('explanation', explanation);
        formData.append('cfo_operation2', cfoMore);
        formData.append('image_name', selectedImage);
        formData.append('image_og', ogImage);

        const res = await axios.post(config.urlApi + `/report/generateRport`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (res.status === 200) {
          await Swal.fire({
            icon: 'success',
            title: 'สำเร็จ',
            text: 'ระบบทำการสร้างรายงานเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });

          fetchData();
        } else {
          throw new Error('การสร้างรายงานไม่สำเร็จ');
        }
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.message,
      });
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axios.get(config.urlApi + `/download-excel/${id}`, {
        responseType: 'blob',
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'cfo.xlsx');
        document.body.appendChild(link);
        link.click();
        Swal.fire({
          icon: 'success',
          title: 'ดาวน์โหลดสำเร็จ',
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true
        });
      } else {
        throw new Error('ดาวน์โหลด Excel ไม่สำเร็จ');
      }

    } catch (error) {
      console.error('Error downloading Excel file: ', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'เกิดข้อผิดพลาดในการดาวน์โหลดไฟล์ Excel',
      });
    }
  };

  const handleGeneratePDF = async () => {
    try {
      const res = await axios.get(config.urlApi + `/generate-pdf/${campus_id}/${fac_id}/${years}/${id}`, {
        responseType: 'blob'
      });

      if (res.status === 200) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        Swal.fire({
          icon: 'success',
          title: 'ดาวน์โหลดสำเร็จ',
          showConfirmButton: false,
          timer: 700,
          timerProgressBar: true
        });
      } else {
        throw new Error('ดาวน์โหลดไม่สำเร็จ');
      }

    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: e.message,
      });
    }
  };

  const handleRemovalReport = async (ReportId) => {
    const result = await Swal.fire({
      icon: 'warning',
      text: 'ต้องการลบรายงานหรือไม่',
      showCancelButton: true,
      confirmButtonText: 'ใช่',
      cancelButtonText: 'ไม่',
      cancelButtonColor: '#B84343'
    });

    if (result.isConfirmed) {
      try {
        const res = await axios.delete(`${config.urlApi}/removeReport/${ReportId}`);
        if (res.status === 200) {
          await Swal.fire({
            icon: "success",
            title: "ลบข้อมูลสำเร็จ",
            timer: 800,
            timerProgressBar: true
          });
          fetchData();
        } else {
          throw new Error('เกิดข้อผิดพลาดในการลบรายงาน');
        }

      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการลบรายงาน",
          text: error.message,
        });
      }
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('th-TH', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div>
      <h2 className='text-center'>รายงาน</h2>
      <div className="card mb-3 shadow-sm border-0">
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h5 className="fw-bold text-success mb-0">รายงานก๊าซเรือนกระจก (Excel)</h5>
            <small className="text-muted">ไฟล์สรุปผลการดำเนินงาน</small>
          </div>
          <button className="btn btn-success d-flex align-items-center gap-2" onClick={handleDownload}>
            <TableViewIcon />
            ดาวน์โหลด Excel
          </button>
        </div>
      </div>

      <h4 className="mt-4 mb-3 fw-bold">รายงานที่สร้างแล้ว</h4>
      {reportData.length > 0 ? (
        reportData.map((report) => (
          <div key={report.id} className="card mb-3 shadow-sm border-0">
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <h6 className="fw-bold mb-1">{report.report_name || "รายงานการดำเนินงาน"}</h6>
                <small className="text-muted">สร้างเมื่อ: {formatDate(report.createdAt)}</small>
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-primary d-flex align-items-center gap-2" onClick={() => handleGeneratePDF(report.id)}>
                  <PictureAsPdfIcon /> PDF
                </button>
                <button className="btn btn-danger d-flex align-items-center gap-2" onClick={() => handleRemovalReport(report.id)}>
                  <DeleteIcon /> ลบ
                </button>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center text-muted fs-5">ยังไม่มีรายงานที่สร้าง</div>
      )}

      {reportData.length === 0 && (
        <div className="text-center mt-4">
          <button
            className="btn btn-primary d-flex align-items-center mx-auto gap-2"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            <AddCircleIcon /> เพิ่มรายงาน
          </button>
        </div>
      )}

      <div
        className="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-2" id="exampleModalLabel">
                แบบฟอร์มการออกรายงาน
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body px-5 py-4">
              <div className="row g-2">
                <div className="mb-4">
                  <label className="h3 fw-cold mb-2">รูปรายงาน</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".jpg, .png, .jpeg"
                    onChange={(e) => setSelectedImage(e.target.files[0])}
                  />
                  {/* ตรวจสอบว่ามีรูปภาพที่ถูกเลือกหรือไม่ */}
                  {selectedImage !== null && (
                    <div className="text-center image-preview mt-4">
                      <img src={URL.createObjectURL(selectedImage)} alt="Selected" />
                    </div>
                  )}
                </div>

                <div className="h3 fw-cold ">บทนำ</div>
                <ReactQuill
                  theme="snow"
                  value={intro}
                  style={{ height: "200px", marginBottom: "50px" }}
                  onChange={(value) => handleQuillChange(value, setIntro)}
                />
                <div className="h3 fw-cold mt-4">ข้อมูลทั่วไป</div>
                <div className="col-md-12">
                  <label>
                    หน่วยงานทวนสอบ
                  </label>
                  <input
                    type="text"
                    onChange={(e) => setTester(e.target.value)}
                    className="form-control"
                  />
                </div>

                <div className="row g-2">
                  <div className="col-md-6">
                    <label>
                      ชื่อ-สกุลของผู้ประสานงาน{" "}

                    </label>
                    <input
                      type="text"
                      onChange={(e) => setCoodinator(e.target.value)}
                      className="form-control"
                    />
                  </div>

                  <div className="col-md-6">
                    <label>เบอร์โทร{" "}</label>
                    <input
                      type="text"
                      onChange={(e) => setCoodinatorPhoneNum(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>


                <div className="row g-2">
                  <div className="col-md-6">
                    <label>
                      ชื่อ-สกุลของผู้รับผิดชอบ{" "}

                    </label>
                    <input
                      type="text"
                      onChange={(e) => setResponsible(e.target.value)}
                      className="form-control"
                    />
                  </div>

                  <div className="col-md-6">
                    <label>เบอร์โทร{" "}</label>
                    <input
                      type="text"
                      onChange={(e) => setResponsiblePhoneNum(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="h3 fw-cold mt-4">ขอบเขตขององค์กร</div>
                <div className="col-md-6">
                  <label>หน่วยสาธารณูปโภค</label>
                  <input
                    type="text"
                    onChange={(e) => setUtility(e.target.value)}
                    className="form-control"
                  />

                </div>

                <div className="col-md-6">
                  <label>เอกสารยืนยันขอบเขต</label>
                  <input
                    type="text"
                    onChange={(e) => setConfirmDoc(e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>

              <label className="mt-2">
                แผนผังการดำเนินงาน (อธิบาย){" "}
              </label>
              <ReactQuill
                theme="snow"
                value={explanation}
                style={{ height: "200px", marginBottom: "50px" }}
                onChange={(value) => handleQuillChange(value, setExplanation)}
              />
              <label>รูปแผนผังการดำเนินงาน</label>
              <input
                type="file"
                className="form-control"
                accept=".jpg, .png, .jpeg"
                onChange={(e) => setOgImage(e.target.files[0])}
              />

              <div className="h3 fw-cold mt-4">ขอบเขตการดำเนินงาน</div>
              <label>
                1.ก๊าซเรือนกระจกที่พิจารณาอื่น ๆเพิ่มเติม{" "}
              </label>
              <ReactQuill
                theme="snow"
                value={cfoMore}
                style={{ height: "200px", marginBottom: "50px" }}
                onChange={(value) => handleQuillChange(value, setCFOMore)}
              />


              <label className="mt-3">2.ระบุขอบเขตขององค์กรที่เพิ่มเข้ามาหรือขอบเขตที่ไม่รวม (ระบุ Facility) ที่เพิ่มเข้ามาหรือไม่นับรวม พร้อมเหตุผล</label>
              <ReactQuill
                theme="snow"
                value={facility}
                style={{ height: "200px", marginBottom: "50px" }}
                onChange={(value) => handleQuillChange(value, setFacility)}
              />

            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                ยกเลิก
              </button>
              <button
                type="button"
                onClick={handlerGenerateReport}
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabActivityReport;
